import * as monacoEditor from 'monaco-editor/esm/vs/editor/editor.api';

// copied from https://github.com/microsoft/monaco-languages/blob/618f2cff2d8e72f04fe9d63085a0c5118b80e8a0/src/graphql/graphql.ts#L11-L37
export const graphqlLanguageConfiguration: monacoEditor.languages.LanguageConfiguration =
  {
    comments: {
      lineComment: '#',
    },
    brackets: [
      ['{', '}'],
      ['[', ']'],
      ['(', ')'],
    ],
    autoClosingPairs: [
      { open: '{', close: '}' },
      { open: '[', close: ']' },
      { open: '(', close: ')' },
      { open: '"""', close: '"""', notIn: ['string', 'comment'] },
      { open: '"', close: '"', notIn: ['string', 'comment'] },
    ],
    surroundingPairs: [
      { open: '{', close: '}' },
      { open: '[', close: ']' },
      { open: '(', close: ')' },
      { open: '"""', close: '"""' },
      { open: '"', close: '"' },
    ],
    folding: {
      offSide: true,
    },
  };
